/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:34:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import OSAdminConsoleApp from "./App";
import reportWebVitals from "./reportWebVitals";
import * as GTM from "./googleTagManager";
import * as Sentry from "./sentry";

GTM.initializeGoogleTagManager();

Sentry.initSentry();

ReactDOM.render(
  <React.StrictMode>
    <OSAdminConsoleApp />
  </React.StrictMode>,
  document.getElementById("onestop-admin")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
